// extracted by mini-css-extract-plugin
export default {"outer":"MainChart_outer__rnjev"};